export const NORMALIZED_HASH_SCROLL_TIMEOUT = 500;
/**
 * When the site gets asynchronously loaded we need to be sure that the elements with id=window.location.hash
 * are properly visible into the viewport
 */
export default function normalizeHashScroll() {
    if (!window.location.hash) {
        return;
    }

    const id = window.location.hash.replace('#', '');
    const el = document.getElementById(decodeURIComponent(id));

    if (el) {
        setTimeout(() => {
            el.scrollIntoView({
                behavior: 'smooth',
            });
        }, NORMALIZED_HASH_SCROLL_TIMEOUT);
    }
}
